import React from 'react'
import s from './setting-row.module.scss'
import classNames from 'classnames'

export const SettingRow = ({title, subtitle, withoutBorders = false, children, disabled = false, centered = false}) => {
	return (
		<div className={classNames(s.row, withoutBorders ? s.withoutBorder : '', disabled ? s.disabled : '', centered ? s.centered : '')}>
			<div className={s.partTitle}>
				{!!subtitle ? <>
					<p className={s.avatarTitle}>{title}</p>
					<p className={s.avatarSubtitle}>
						{subtitle}
					</p>
				</> : title}
			</div>
			<div className={s.partForm}>
				{children}
			</div>
		</div>
	)
}
